var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.documents),function(document,index){return _c('div',{key:document.location},[_c('document-item',{attrs:{"document":document,"index":index},on:{"delete":function($event){return _vm.remove($event)}}})],1)}),0)}
var staticRenderFns = []

export { render, staticRenderFns }